import { StyledFooter } from "./styled";

const Footer = ({ footerExtraContent }) => (
  <StyledFooter>
    {footerExtraContent}
  </StyledFooter>
);

export default Footer;
